export default {
  name: 'repelente-insectos',
  label: 'repelente de insectos',
  notes: [
    'se puede usar con cremas de pepino o áloe, preparar lociones y con aceites base como el olivo'
  ],
  formula: [
    {
      name: 'aceite esencial de ylang ylang',
      quantity: 4,
      unit: 'ml',
      ref: 'ylang-ylang'
    },
    {
      name: 'aceite esencial de bergamota',
      quantity: 3.75,
      unit: 'ml',
      ref: 'bergamota'
    },
    {
      name: 'aceite esencial de lavanda',
      quantity: 5,
      unit: 'ml',
      ref: 'lavanda'
    },
    {
      name: 'aceite esencial de romero',
      quantity: 7,
      unit: 'ml',
      ref: 'romero'
    },
    {
      name: 'aceite esencial de hierbabuena',
      quantity: 3.75,
      unit: 'ml',
      ref: 'hierbabuena'
    },
    {
      name: 'aceite esencial de citronela',
      quantity: 10,
      unit: 'ml',
      ref: 'citronela'
    },
  ],
}
